/* COOKIE FOR GDPR VALIDATION */
if (document.querySelectorAll('.cookie-validate').length > 0) {
	$('body').addClass('gv');
	document.querySelector('.cookie-validate').addEventListener('click', function (e) {
		e.preventDefault();
		Cookies.set('gdpr-validated', true, { expires: 90 });
		document.querySelector('.cookie-popin').classList.add('close');
		$('body').removeClass('gv');

		jQuery.get( PATH_TO_THEME + '/partials/analytics.php', function(analytics){
			$('body').append(analytics);
		}, 'html');
	});
}

// SCROLL TO ID & #REMOVAL
$(function() {
	$('a[href*="#"]:not([href="#"])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1500);
				return false;
			}
		}
	});
});

$('.container_menu a').on('click', function (e) {
	if ($(this).next('ul').length == 0 && $(this).attr('href').indexOf('#') > -1) {
		$('.burger-click-region').addClass('closing').removeClass('active');
		$('body').removeClass('open');
		$('.burger-click-region').parent().toggleClass('is-open');
		setTimeout(function( ) {
			$('.burger-click-region').removeClass('closing');
		}, clickDelay);
	}
});

$('.arrow-scroll').click(function () {
	$.fn.fullpage.moveSectionDown();
});

$('.scroll').click(function(){
	
	if($(this).hasClass('up')) {
		$.fn.fullpage.moveSectionUp();
	} else {
		$.fn.fullpage.moveSectionDown();
	}
	
	return false;
});

// AUTO MOSAIC HEIGHT

var AutoMosaicheight = function(){
	$('.album').each(function(){
		$(this).css('height', $(this).width() + 'px');
	});
};

$(document).ready(AutoMosaicheight);
$(window).resize(AutoMosaicheight);

// FANCYBOX PARAMETERS
	$.fancybox.defaults.thumbs = {
		autoStart: true,
		hideOnClose: true,
		parentEl: ".fancybox-container",
		axis: 'x'
	};
	$.fancybox.defaults.buttons = ["close"];
	$.fancybox.defaults.wheel = false;
	$.fancybox.defaults.idleTime = 5;
	$.fancybox.defaults.transitionEffect = false;
	$.fancybox.defaults.loop = true;

	var w = 0;

	$('[data-fancybox]').fancybox({
		onActivate: function (i, s) {
			w = $('.fancybox-thumbs__list a:first').outerWidth(true);
			$('.fancybox-thumbs__list').css(/*{*/
				'padding', '0 calc(50% - ' + w/2 + 'px)'
			/*}*/);/*
				'margin-left': '0 -' + w/2 + 'px'

			$('.fancybox-thumbs__list a').click(function () {
				index = $('.fancybox-thumbs__list a').index(this);
				$('.fancybox-thumbs__list').css('margin-left', -w*index);
			});*/
		},
		/*onDeactivate: function (i, s) {
			$('.fancybox-thumbs__list a').off('click');
			$('.fancybox-button').fadeOut(366);
		}*/
	});

// SUBMENU TRIGGER

function menuSlideToggle () {
	$('header .submenu').mouseenter(function() {
		$('body:not(.open) .drop-down').slideDown(400);
		$('header .submenu').off('mouseenter');
		$('header .submenu').off('mouseleave');

		setTimeout(menuSlideToggle, 400);
	});

	$('header .submenu').mouseleave(function() {
		$('body:not(.open) .drop-down').slideUp(400);
		$('header .submenu').off('mouseenter');
		$('header .submenu').off('mouseleave');
		setTimeout(menuSlideToggle, 400);
	});
}

menuSlideToggle();

$('header .submenu').click(function() {
	$('body.open .drop-down').slideToggle(400);
});

$('section').click(function() {
	$('body.open .drop-down').slideToggle(400);
});

// FULLPAGE SYSTEM

$(document).ready(function() {

	responsiveBurgerMenu();
	
	var sections = $('#fullpage section');
	
	if(sections.length > 0) {
		
		var ids = [];
		sections.each(function(){
			ids.push( $(this).data('anchor') );
		});
				
		$('#fullpage').fullpage({

			//Navigation
			menu: '#header',
			lockAnchors: false,
			anchors:ids,
			navigation: false,
			navigationPosition: 'right',
			navigationTooltips: ['firstSlide', 'secondSlide'],
			showActiveTooltip: false,
			slidesNavigation: false,
			slidesNavPosition: 'bottom',
	
			//Scrolling
			css3: true,
			scrollingSpeed: 700,
			autoScrolling: true,
			fitToSection: true,
			fitToSectionDelay: 1000,
			scrollBar: true,
			easing: 'easeInOutCubic',
			easingcss3: 'ease',
			loopBottom: false,
			loopTop: false,
			loopHorizontal: true,
			continuousVertical: false,
			continuousHorizontal: false,
			scrollHorizontally: false,
			interlockedSlides: false,
			dragAndMove: false,
			offsetSections: false,
			resetSliders: false,
			fadingEffect: false,
			normalScrollElements: '#element1, .element2',
			scrollOverflow: false,
			scrollOverflowReset: false,
			scrollOverflowOptions: null,
			touchSensitivity: 15,
			normalScrollElementTouchThreshold: 5,
			bigSectionsDestination: null,
	
			//Accessibility
			keyboardScrolling: true,
			animateAnchor: true,
			recordHistory: true,
	
			//Design
			controlArrows: true,
			verticalCentered: false,
			sectionsColor : ['#ccc', '#fff'],
			paddingTop: '0px',
			paddingBottom: '0px',
			fixedElements: '#header, .footer',
			responsiveWidth: 768,
			responsiveHeight: 768,
			responsiveSlides: false,
			parallax: false,
			parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},
	
			//Custom selectors
			sectionSelector: '.section',
			slideSelector: '.slide',
	
			lazyLoading: true,
	
			//events
			onLeave: function(index, nextIndex, direction){
				
				$('body.white').removeClass('page-left').removeClass('page-right');
				var section = $(sections.get(nextIndex-1));
				var pageLayout = section.data('page-layout');
				
				// console.log(section);
				if(pageLayout) {
					$('body.white').addClass(pageLayout);
				}
			},
			afterLoad: function(anchorLink, index){
				if ($(window).width() < 768) {
					$('#fullpage section').css('height', 'auto');
				}
			},
			afterRender: function(){},
			afterResize: function(){
				if ($(window).width() < 768) {
					$('#fullpage section').css('height', 'auto');
				}
			},
			afterResponsive: function(isResponsive){},
			afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){},
			onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){}
		});

	}






	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	$('#form_contact .required').focus( function(){
		$(this).removeClass('error-warning');
	});

	$('#form_contact').submit( function(){

		var error = false;

		$(this).find(".required").each(function(){
			if($(this).val().trim().length <= 0){
				error = true;
				$(this).addClass('error-warning');
			}
		});
		$(this).find('input[name=email]').each(function(){
			if( !validateEmail($(this).val()) ) {
				error = true;
				$(this).addClass('error-warning');
			}	
		});

		return !error;
	});


});
// $(window).scroll(function () {
//     if ($(this).scrollTop() > $('section:first').height()-5 && !$('body').hasClass('burger')) {
// 		$('body').addClass('burger');
// 		setTimeout(function(){
// 	       $("body.burger .container_menu ul").addClass("show");
// 		}, 800);
// 	} else if ($(this).scrollTop() < $('section:first').height()-5 && $('body').hasClass('burger')) {
// 		$('body').removeClass('burger');
// 		$(".show").removeClass("show");
// 	}
// });

function initMap() {
	var mapOptions = {
		zoom: 14,

		center: new google.maps.LatLng(50.8802394,4.3792842), 
		styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
	};
	// center: new google.maps.LatLng(50.8800147, 4.3567042), C'est bien beau d'avoir décentré, mais en mobile le point n'est plus visible
	
	var mapElement = document.getElementById('map');

	var map = new google.maps.Map(mapElement, mapOptions);

	var marker = new google.maps.Marker(
		{
			position: new google.maps.LatLng(50.8802394,4.3792842),
			map: map,
			icon: "/sites/all/themes/menuiseriebrabant/dist/img/menuiserie.png",
			title: 'Vanhumbeeck frères'
		}
	);
}

$(window).on('scroll', function() {
	if ($(window).width() >= 1024) {
		if ($('body').hasClass('open')) { /* make it better if possible */
			return false;
		}

		var headerHeight = $( window ).height() - 1;
		if ($(window).scrollTop() > (headerHeight / 2)) {
			$("body").addClass('scrolled');
			$("div.burger-menu").fadeIn(300);
		}
		else {
			$("body").removeClass('scrolled');
			$("div.burger-menu").fadeOut(300);
		}
	}
});

$(window).resize(responsiveBurgerMenu);

var clickDelay      = 500,
    clickDelayTimer = null;

$('.burger-click-region').on('click', function () {
  
	if(clickDelayTimer === null) {

		var $burger = $(this);
		$burger.toggleClass('active');
		$burger.parent().toggleClass('is-open');
		$("body").addClass('open');

		if(!$burger.hasClass('active')) {
			$burger.addClass('closing');
			$("body").removeClass('open');
		}

		clickDelayTimer = setTimeout(function () {
			$burger.removeClass('closing');
			clearTimeout(clickDelayTimer);
			clickDelayTimer = null;
		}, clickDelay);
	}
});

// $(document).ready(function(){
// 	setTimeout(function(){
// 		if ($(window).width() > 960){
// 			$(".menu").addClass('first_menu');
// 			$(".menu").removeClass('submenu');
// 		}
// 	},600);
	
// });

// SCROLL REVEAL.JS

/*window.sr = ScrollReveal({ 

  reset:        true, 
  mobile:       false, 
  viewFactor:   0.15,
  duration:     800,
  origin:       'bottom',
  distance:     '100px',

});


// VIEWPORT DELAY

sr.reveal('section h1'      , {distance:'0px' , delay: 0   });
sr.reveal('section h2'      , {distance:'0px' , delay: 50   });
sr.reveal('section p'  		, {distance:'0px' , delay: 100  });
sr.reveal('section body.other .category-content-txt'  		, {distance:'0px' , delay: 20  }); 
sr.reveal('section section a'  		, {distance:'0px' , delay: 150  }); 
sr.reveal('section input'      , {distance:'0px' , delay: 50   });
sr.reveal('section textarea'      , {distance:'0px' , delay: 50   });
sr.reveal('section button'      , {distance:'0px' , delay: 100   });
sr.reveal('section .img'      , {distance:'0px' , delay: 50   }); */

// Contact form


$(document).ready(function(){

	$('#form_contact input[name=_token]').remove();
	$('#form_contact input').focus(function(){ $(this).removeClass('error-warning'); });
	$('#form_contact').submit(function(){

		var error = false;

		$(this).find('input.required').each(function(){
			if($(this).val().trim().length <= 0 ){
				error = true;
				$(this).addClass('error-warning');
			}
		});
		
		return !error;
	});
	
	$('.modal .close').click(function(){
		$(this).parents('.modal').fadeOut(function(){
			$(this).remove();
		});
		
		return false;
	});
});



/* Functions */
function responsiveBurgerMenu () {
	if ($(window).width() < 1024) {
		$('body').addClass('scrolled');
		$('div.burger-menu').fadeIn();
	} else if ($(window).width() >= 1024 && $(window).scrollTop() > $(window).height() / 2) {
		$('body').addClass('scrolled');
		$('div.burger-menu').fadeIn();
	} else if ($(window).width() >= 1024 && $(window).scrollTop() < $(window).height() / 2) {
		$('body').removeClass('scrolled');
		$('div.burger-menu').fadeOut();
	}
}
